import { connect } from "react-redux";
import LiveTr from "./Tr";
import { deleteLiveCampaign } from "../../../../store/action/liveCampaignAction";
const _ = require('lodash')

const LiveTable = (props) => {
   const { data, deleteLiveCampaign } = props;

   return (
      <table className="app-table app-table--vertical-middle">
         <thead>
            <tr>
               <th className="" style={{ width: 45 }}><span></span></th>
               <th className=""><span>Chiến dịch</span></th>
               <th className="" style={{ width: 160 }}><span>Trang</span></th>
               <th className="" style={{ width: 160 }}><span>Trạng thái</span></th>
               <th className="" style={{ width: 128 }}><span>Phương thức <br />chốt đơn</span></th>
               <th className="text-right"><span>Khách có <br /> số điện thoại</span></th>
               <th className="text-right"><span>Tổng số <br /> bình luận</span></th>
               <th className="text-right"><span>Tổng số bình luận<br />đúng cú pháp</span></th>
               <th className="header-with-tooltip text-right">
                  <span>
                     <div>Tổng số đơn <br /> tạm tính</div><span className="pointer">
                        {/* <div className="svg-next-icon ic-help">
                        </div> */}
                     </span>
                  </span>
               </th>
               <th className="header-with-tooltip text-right">
                  <span>
                     <div>Doanh thu <br /> tạm tính</div><span className="pointer">
                        {/* <div className="svg-next-icon ic-help">
                        </div> */}
                     </span>
                  </span>
               </th>
               <th className="text-center"><span>Hành <br /> động</span></th>
            </tr>
         </thead>
         <tbody>
            {data.map((item, index) => (<LiveTr data={item} key={index} stt={index + 1} onDelete={deleteLiveCampaign}/>))}
         </tbody>
      </table>
   )
}

const mapStateToProps = (state) => {
   const { liveCampaign } = state;
   return {
      data: _.isArray(liveCampaign?.items) ? liveCampaign.items : []
   }
}

export default connect(mapStateToProps, {
   deleteLiveCampaign
})(LiveTable);